import { render, staticRenderFns } from "./ProductPurchasePaypal.vue?vue&type=template&id=6ee26742&"
import script from "./ProductPurchasePaypal.vue?vue&type=script&lang=js&"
export * from "./ProductPurchasePaypal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports